"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNeedMoreInfoErrors = exports.getNeedMoreInfoIsLoading = exports.getNeedMoreInfoState = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _root = require("../root.selector");

var getNeedMoreInfoState = R.compose(R.prop('needMoreInfo'), _root.getContactDetailsState);
exports.getNeedMoreInfoState = getNeedMoreInfoState;
var getNeedMoreInfoIsLoading = R.compose(R.prop('isLoading'), getNeedMoreInfoState);
exports.getNeedMoreInfoIsLoading = getNeedMoreInfoIsLoading;
var getNeedMoreInfoErrors = R.compose(R.prop('errors'), getNeedMoreInfoState);
exports.getNeedMoreInfoErrors = getNeedMoreInfoErrors;